import { GB, ZA, IN, AU, GLOBAL } from '@clearscore/config.i18n';

import gb00Theta1920w from './gb/00_Theta/1920w/background.jpg';
import gb00ThetaBlur1920w from './gb/00_Theta-blur/1920w/background.jpg';
import gb00Theta1280w from './gb/00_Theta/1280w/background.jpg';
import gb00ThetaBlur1280w from './gb/00_Theta-blur/1280w/background.jpg';
import gb00Theta720w from './gb/00_Theta/720w/background.jpg';
import gb00ThetaBlur720w from './gb/00_Theta-blur/720w/background.jpg';
import gb01Alpha1920w from './gb/01_Alpha/1920w/background.jpg';
import gb01AlphaBlur1920w from './gb/01_Alpha-blur/1920w/background.jpg';
import gb01Alpha1280w from './gb/01_Alpha/1280w/background.jpg';
import gb01AlphaBlur1280w from './gb/01_Alpha-blur/1280w/background.jpg';
import gb01Alpha720w from './gb/01_Alpha/720w/background.jpg';
import gb01AlphaBlur720w from './gb/01_Alpha-blur/720w/background.jpg';
import gb02Beta1920w from './gb/02_Beta/1920w/background.jpg';
import gb02BetaBlur1920w from './gb/02_Beta-blur/1920w/background.jpg';
import gb02Beta1280w from './gb/02_Beta/1280w/background.jpg';
import gb02BetaBlur1280w from './gb/02_Beta-blur/1280w/background.jpg';
import gb02Beta720w from './gb/02_Beta/720w/background.jpg';
import gb02BetaBlur720w from './gb/02_Beta-blur/720w/background.jpg';
import gb03Gamma1920w from './gb/03_Gamma/1920w/background.jpg';
import gb03GammaBlur1920w from './gb/03_Gamma-blur/1920w/background.jpg';
import gb03Gamma1280w from './gb/03_Gamma/1280w/background.jpg';
import gb03GammaBlur1280w from './gb/03_Gamma-blur/1280w/background.jpg';
import gb03Gamma720w from './gb/03_Gamma/720w/background.jpg';
import gb03GammaBlur720w from './gb/03_Gamma-blur/720w/background.jpg';
import gb04Delta1920w from './gb/04_Delta/1920w/background.jpg';
import gb04DeltaBlur1920w from './gb/04_Delta-blur/1920w/background.jpg';
import gb04Delta1280w from './gb/04_Delta/1280w/background.jpg';
import gb04DeltaBlur1280w from './gb/04_Delta-blur/1280w/background.jpg';
import gb04Delta720w from './gb/04_Delta/720w/background.jpg';
import gb04DeltaBlur720w from './gb/04_Delta-blur/720w/background.jpg';
import gb05Epsilon1920w from './gb/05_Epsilon/1920w/background.jpg';
import gb05EpsilonBlur1920w from './gb/05_Epsilon-blur/1920w/background.jpg';
import gb05Epsilon1280w from './gb/05_Epsilon/1280w/background.jpg';
import gb05EpsilonBlur1280w from './gb/05_Epsilon-blur/1280w/background.jpg';
import gb05Epsilon720w from './gb/05_Epsilon/720w/background.jpg';
import gb05EpsilonBlur720w from './gb/05_Epsilon-blur/720w/background.jpg';
import in00Theta1920w from './in/00_Theta/1920w/background.jpg';
import in00ThetaBlur1920w from './in/00_Theta-blur/1920w/background.jpg';
import in00Theta1280w from './in/00_Theta/1280w/background.jpg';
import in00ThetaBlur1280w from './in/00_Theta-blur/1280w/background.jpg';
import in00Theta720w from './in/00_Theta/720w/background.jpg';
import in00ThetaBlur720w from './in/00_Theta-blur/720w/background.jpg';
import in01Alpha1920w from './in/01_Alpha/1920w/background.jpg';
import in01AlphaBlur1920w from './in/01_Alpha-blur/1920w/background.jpg';
import in01Alpha1280w from './in/01_Alpha/1280w/background.jpg';
import in01AlphaBlur1280w from './in/01_Alpha-blur/1280w/background.jpg';
import in01Alpha720w from './in/01_Alpha/720w/background.jpg';
import in01AlphaBlur720w from './in/01_Alpha-blur/720w/background.jpg';
import in02Beta1920w from './in/02_Beta/1920w/background.jpg';
import in02BetaBlur1920w from './in/02_Beta-blur/1920w/background.jpg';
import in02Beta1280w from './in/02_Beta/1280w/background.jpg';
import in02BetaBlur1280w from './in/02_Beta-blur/1280w/background.jpg';
import in02Beta720w from './in/02_Beta/720w/background.jpg';
import in02BetaBlur720w from './in/02_Beta-blur/720w/background.jpg';
import in03Gamma1920w from './in/03_Gamma/1920w/background.jpg';
import in03GammaBlur1920w from './in/03_Gamma-blur/1920w/background.jpg';
import in03Gamma1280w from './in/03_Gamma/1280w/background.jpg';
import in03GammaBlur1280w from './in/03_Gamma-blur/1280w/background.jpg';
import in03Gamma720w from './in/03_Gamma/720w/background.jpg';
import in03GammaBlur720w from './in/03_Gamma-blur/720w/background.jpg';
import in04Delta1920w from './in/04_Delta/1920w/background.jpg';
import in04DeltaBlur1920w from './in/04_Delta-blur/1920w/background.jpg';
import in04Delta1280w from './in/04_Delta/1280w/background.jpg';
import in04DeltaBlur1280w from './in/04_Delta-blur/1280w/background.jpg';
import in04Delta720w from './in/04_Delta/720w/background.jpg';
import in04DeltaBlur720w from './in/04_Delta-blur/720w/background.jpg';
import in05Epsilon1920w from './in/05_Epsilon/1920w/background.jpg';
import in05EpsilonBlur1920w from './in/05_Epsilon-blur/1920w/background.jpg';
import in05Epsilon1280w from './in/05_Epsilon/1280w/background.jpg';
import in05EpsilonBlur1280w from './in/05_Epsilon-blur/1280w/background.jpg';
import in05Epsilon720w from './in/05_Epsilon/720w/background.jpg';
import in05EpsilonBlur720w from './in/05_Epsilon-blur/720w/background.jpg';
import za00Theta1920w from './za/00_Theta/1920w/background.jpg';
import za00ThetaBlur1920w from './za/00_Theta-blur/1920w/background.jpg';
import za00Theta1280w from './za/00_Theta/1280w/background.jpg';
import za00ThetaBlur1280w from './za/00_Theta-blur/1280w/background.jpg';
import za00Theta720w from './za/00_Theta/720w/background.jpg';
import za00ThetaBlur720w from './za/00_Theta-blur/720w/background.jpg';
import za01Alpha1920w from './za/01_Alpha/1920w/background.jpg';
import za01AlphaBlur1920w from './za/01_Alpha-blur/1920w/background.jpg';
import za01Alpha1280w from './za/01_Alpha/1280w/background.jpg';
import za01AlphaBlur1280w from './za/01_Alpha-blur/1280w/background.jpg';
import za01Alpha720w from './za/01_Alpha/720w/background.jpg';
import za01AlphaBlur720w from './za/01_Alpha-blur/720w/background.jpg';
import za02Beta1920w from './za/02_Beta/1920w/background.jpg';
import za02BetaBlur1920w from './za/02_Beta-blur/1920w/background.jpg';
import za02Beta1280w from './za/02_Beta/1280w/background.jpg';
import za02BetaBlur1280w from './za/02_Beta-blur/1280w/background.jpg';
import za02Beta720w from './za/02_Beta/720w/background.jpg';
import za02BetaBlur720w from './za/02_Beta-blur/720w/background.jpg';
import za03Gamma1920w from './za/03_Gamma/1920w/background.jpg';
import za03GammaBlur1920w from './za/03_Gamma-blur/1920w/background.jpg';
import za03Gamma1280w from './za/03_Gamma/1280w/background.jpg';
import za03GammaBlur1280w from './za/03_Gamma-blur/1280w/background.jpg';
import za03Gamma720w from './za/03_Gamma/720w/background.jpg';
import za03GammaBlur720w from './za/03_Gamma-blur/720w/background.jpg';
import za04Delta1920w from './za/04_Delta/1920w/background.jpg';
import za04DeltaBlur1920w from './za/04_Delta-blur/1920w/background.jpg';
import za04Delta1280w from './za/04_Delta/1280w/background.jpg';
import za04DeltaBlur1280w from './za/04_Delta-blur/1280w/background.jpg';
import za04Delta720w from './za/04_Delta/720w/background.jpg';
import za04DeltaBlur720w from './za/04_Delta-blur/720w/background.jpg';
import za05Epsilon1920w from './za/05_Epsilon/1920w/background.jpg';
import za05EpsilonBlur1920w from './za/05_Epsilon-blur/1920w/background.jpg';
import za05Epsilon1280w from './za/05_Epsilon/1280w/background.jpg';
import za05EpsilonBlur1280w from './za/05_Epsilon-blur/1280w/background.jpg';
import za05Epsilon720w from './za/05_Epsilon/720w/background.jpg';
import za05EpsilonBlur720w from './za/05_Epsilon-blur/720w/background.jpg';
import au00Theta1920w from './au/00_Theta/1920w/background.jpg';
import au00ThetaBlur1920w from './au/00_Theta-blur/1920w/background.jpg';
import au00Theta1280w from './au/00_Theta/1280w/background.jpg';
import au00ThetaBlur1280w from './au/00_Theta-blur/1280w/background.jpg';
import au00Theta720w from './au/00_Theta/720w/background.jpg';
import au00ThetaBlur720w from './au/00_Theta-blur/720w/background.jpg';
import au01Alpha1920w from './au/01_Alpha/1920w/background.jpg';
import au01AlphaBlur1920w from './au/01_Alpha-blur/1920w/background.jpg';
import au01Alpha1280w from './au/01_Alpha/1280w/background.jpg';
import au01AlphaBlur1280w from './au/01_Alpha-blur/1280w/background.jpg';
import au01Alpha720w from './au/01_Alpha/720w/background.jpg';
import au01AlphaBlur720w from './au/01_Alpha-blur/720w/background.jpg';
import au02Beta1920w from './au/02_Beta/1920w/background.jpg';
import au02BetaBlur1920w from './au/02_Beta-blur/1920w/background.jpg';
import au02Beta1280w from './au/02_Beta/1280w/background.jpg';
import au02BetaBlur1280w from './au/02_Beta-blur/1280w/background.jpg';
import au02Beta720w from './au/02_Beta/720w/background.jpg';
import au02BetaBlur720w from './au/02_Beta-blur/720w/background.jpg';
import au03Gamma1920w from './au/03_Gamma/1920w/background.jpg';
import au03GammaBlur1920w from './au/03_Gamma-blur/1920w/background.jpg';
import au03Gamma1280w from './au/03_Gamma/1280w/background.jpg';
import au03GammaBlur1280w from './au/03_Gamma-blur/1280w/background.jpg';
import au03Gamma720w from './au/03_Gamma/720w/background.jpg';
import au03GammaBlur720w from './au/03_Gamma-blur/720w/background.jpg';
import au04Delta1920w from './au/04_Delta/1920w/background.jpg';
import au04DeltaBlur1920w from './au/04_Delta-blur/1920w/background.jpg';
import au04Delta1280w from './au/04_Delta/1280w/background.jpg';
import au04DeltaBlur1280w from './au/04_Delta-blur/1280w/background.jpg';
import au04Delta720w from './au/04_Delta/720w/background.jpg';
import au04DeltaBlur720w from './au/04_Delta-blur/720w/background.jpg';
import au05Epsilon1920w from './au/05_Epsilon/1920w/background.jpg';
import au05EpsilonBlur1920w from './au/05_Epsilon-blur/1920w/background.jpg';
import au05Epsilon1280w from './au/05_Epsilon/1280w/background.jpg';
import au05EpsilonBlur1280w from './au/05_Epsilon-blur/1280w/background.jpg';
import au05Epsilon720w from './au/05_Epsilon/720w/background.jpg';
import au05EpsilonBlur720w from './au/05_Epsilon-blur/720w/background.jpg';
import defaultImage from './default.png';
// SPRING PROMO START
// DAY
import spDay720w from './gb/SpringPromoDay/720w.jpg';
import spDay1280w from './gb/SpringPromoDay/1280w.jpg';
import spDay1920w from './gb/SpringPromoDay/1920w.jpg';
import spDayBlur720w from './gb/SpringPromoDay-blur/720w.jpg';
import spDayBlur1280w from './gb/SpringPromoDay-blur/1280w.jpg';
import spDayBlur1920w from './gb/SpringPromoDay-blur/1920w.jpg';
// NIGHT
import spNight720w from './gb/SpringPromoNight/720w.jpg';
import spNight1280w from './gb/SpringPromoNight/1280w.jpg';
import spNight1920w from './gb/SpringPromoNight/1920w.jpg';
import spNightBlur720w from './gb/SpringPromoNight-blur/720w.jpg';
import spNightBlur1280w from './gb/SpringPromoNight-blur/1280w.jpg';
import spNightBlur1920w from './gb/SpringPromoNight-blur/1920w.jpg';

export const SPRING_PROMO_DAY = 'sp_day';
export const SPRING_PROMO_NIGHT = 'sp_night';
// SPRING PROMO END

export const IMAGE_NORMAL = 'normal';
export const IMAGE_BLURRED = 'blurred';

const backgroundsGB = {
    default: defaultImage,
    'no-file': {
        desktop: {
            [IMAGE_NORMAL]: gb00Theta1920w,
            [IMAGE_BLURRED]: gb00ThetaBlur1920w,
        },
        tablet: {
            [IMAGE_NORMAL]: gb00Theta1280w,
            [IMAGE_BLURRED]: gb00ThetaBlur1280w,
        },
        mobile: {
            [IMAGE_NORMAL]: gb00Theta720w,
            [IMAGE_BLURRED]: gb00ThetaBlur720w,
        },
    },
    alpha: {
        desktop: {
            [IMAGE_NORMAL]: gb01Alpha1920w,
            [IMAGE_BLURRED]: gb01AlphaBlur1920w,
        },
        tablet: {
            [IMAGE_NORMAL]: gb01Alpha1280w,
            [IMAGE_BLURRED]: gb01AlphaBlur1280w,
        },
        mobile: {
            [IMAGE_NORMAL]: gb01Alpha720w,
            [IMAGE_BLURRED]: gb01AlphaBlur720w,
        },
    },
    beta: {
        desktop: {
            [IMAGE_NORMAL]: gb02Beta1920w,
            [IMAGE_BLURRED]: gb02BetaBlur1920w,
        },
        tablet: {
            [IMAGE_NORMAL]: gb02Beta1280w,
            [IMAGE_BLURRED]: gb02BetaBlur1280w,
        },
        mobile: {
            [IMAGE_NORMAL]: gb02Beta720w,
            [IMAGE_BLURRED]: gb02BetaBlur720w,
        },
    },
    gamma: {
        desktop: {
            [IMAGE_NORMAL]: gb03Gamma1920w,
            [IMAGE_BLURRED]: gb03GammaBlur1920w,
        },
        tablet: {
            [IMAGE_NORMAL]: gb03Gamma1280w,
            [IMAGE_BLURRED]: gb03GammaBlur1280w,
        },
        mobile: {
            [IMAGE_NORMAL]: gb03Gamma720w,
            [IMAGE_BLURRED]: gb03GammaBlur720w,
        },
    },
    delta: {
        desktop: {
            [IMAGE_NORMAL]: gb04Delta1920w,
            [IMAGE_BLURRED]: gb04DeltaBlur1920w,
        },
        tablet: {
            [IMAGE_NORMAL]: gb04Delta1280w,
            [IMAGE_BLURRED]: gb04DeltaBlur1280w,
        },
        mobile: {
            [IMAGE_NORMAL]: gb04Delta720w,
            [IMAGE_BLURRED]: gb04DeltaBlur720w,
        },
    },
    epsilon: {
        desktop: {
            [IMAGE_NORMAL]: gb05Epsilon1920w,
            [IMAGE_BLURRED]: gb05EpsilonBlur1920w,
        },
        tablet: {
            [IMAGE_NORMAL]: gb05Epsilon1280w,
            [IMAGE_BLURRED]: gb05EpsilonBlur1280w,
        },
        mobile: {
            [IMAGE_NORMAL]: gb05Epsilon720w,
            [IMAGE_BLURRED]: gb05EpsilonBlur720w,
        },
    },
    [SPRING_PROMO_DAY]: {
        desktop: {
            [IMAGE_NORMAL]: spDay1920w,
            [IMAGE_BLURRED]: spDayBlur1920w,
        },
        tablet: {
            [IMAGE_NORMAL]: spDay1280w,
            [IMAGE_BLURRED]: spDayBlur1280w,
        },
        mobile: {
            [IMAGE_NORMAL]: spDay720w,
            [IMAGE_BLURRED]: spDayBlur720w,
        },
    },
    [SPRING_PROMO_NIGHT]: {
        desktop: {
            [IMAGE_NORMAL]: spNight1920w,
            [IMAGE_BLURRED]: spNightBlur1920w,
        },
        tablet: {
            [IMAGE_NORMAL]: spNight1280w,
            [IMAGE_BLURRED]: spNightBlur1280w,
        },
        mobile: {
            [IMAGE_NORMAL]: spNight720w,
            [IMAGE_BLURRED]: spNightBlur720w,
        },
    },
};

export default {
    [GLOBAL]: backgroundsGB,
    [GB]: backgroundsGB,
    [IN]: {
        default: defaultImage,
        'no-file': {
            desktop: {
                [IMAGE_NORMAL]: in00Theta1920w,
                [IMAGE_BLURRED]: in00ThetaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: in00Theta1280w,
                [IMAGE_BLURRED]: in00ThetaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: in00Theta720w,
                [IMAGE_BLURRED]: in00ThetaBlur720w,
            },
        },
        alpha: {
            desktop: {
                [IMAGE_NORMAL]: in01Alpha1920w,
                [IMAGE_BLURRED]: in01AlphaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: in01Alpha1280w,
                [IMAGE_BLURRED]: in01AlphaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: in01Alpha720w,
                [IMAGE_BLURRED]: in01AlphaBlur720w,
            },
        },
        beta: {
            desktop: {
                [IMAGE_NORMAL]: in02Beta1920w,
                [IMAGE_BLURRED]: in02BetaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: in02Beta1280w,
                [IMAGE_BLURRED]: in02BetaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: in02Beta720w,
                [IMAGE_BLURRED]: in02BetaBlur720w,
            },
        },
        gamma: {
            desktop: {
                [IMAGE_NORMAL]: in03Gamma1920w,
                [IMAGE_BLURRED]: in03GammaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: in03Gamma1280w,
                [IMAGE_BLURRED]: in03GammaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: in03Gamma720w,
                [IMAGE_BLURRED]: in03GammaBlur720w,
            },
        },
        delta: {
            desktop: {
                [IMAGE_NORMAL]: in04Delta1920w,
                [IMAGE_BLURRED]: in04DeltaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: in04Delta1280w,
                [IMAGE_BLURRED]: in04DeltaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: in04Delta720w,
                [IMAGE_BLURRED]: in04DeltaBlur720w,
            },
        },
        epsilon: {
            desktop: {
                [IMAGE_NORMAL]: in05Epsilon1920w,
                [IMAGE_BLURRED]: in05EpsilonBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: in05Epsilon1280w,
                [IMAGE_BLURRED]: in05EpsilonBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: in05Epsilon720w,
                [IMAGE_BLURRED]: in05EpsilonBlur720w,
            },
        },
    },
    [ZA]: {
        default: defaultImage,
        'no-file': {
            desktop: {
                [IMAGE_NORMAL]: za00Theta1920w,
                [IMAGE_BLURRED]: za00ThetaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: za00Theta1280w,
                [IMAGE_BLURRED]: za00ThetaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: za00Theta720w,
                [IMAGE_BLURRED]: za00ThetaBlur720w,
            },
        },
        alpha: {
            desktop: {
                [IMAGE_NORMAL]: za01Alpha1920w,
                [IMAGE_BLURRED]: za01AlphaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: za01Alpha1280w,
                [IMAGE_BLURRED]: za01AlphaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: za01Alpha720w,
                [IMAGE_BLURRED]: za01AlphaBlur720w,
            },
        },
        beta: {
            desktop: {
                [IMAGE_NORMAL]: za02Beta1920w,
                [IMAGE_BLURRED]: za02BetaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: za02Beta1280w,
                [IMAGE_BLURRED]: za02BetaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: za02Beta720w,
                [IMAGE_BLURRED]: za02BetaBlur720w,
            },
        },
        gamma: {
            desktop: {
                [IMAGE_NORMAL]: za03Gamma1920w,
                [IMAGE_BLURRED]: za03GammaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: za03Gamma1280w,
                [IMAGE_BLURRED]: za03GammaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: za03Gamma720w,
                [IMAGE_BLURRED]: za03GammaBlur720w,
            },
        },
        delta: {
            desktop: {
                [IMAGE_NORMAL]: za04Delta1920w,
                [IMAGE_BLURRED]: za04DeltaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: za04Delta1280w,
                [IMAGE_BLURRED]: za04DeltaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: za04Delta720w,
                [IMAGE_BLURRED]: za04DeltaBlur720w,
            },
        },
        epsilon: {
            desktop: {
                [IMAGE_NORMAL]: za05Epsilon1920w,
                [IMAGE_BLURRED]: za05EpsilonBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: za05Epsilon1280w,
                [IMAGE_BLURRED]: za05EpsilonBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: za05Epsilon720w,
                [IMAGE_BLURRED]: za05EpsilonBlur720w,
            },
        },
    },
    [AU]: {
        default: defaultImage,
        'no-file': {
            desktop: {
                [IMAGE_NORMAL]: au00Theta1920w,
                [IMAGE_BLURRED]: au00ThetaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: au00Theta1280w,
                [IMAGE_BLURRED]: au00ThetaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: au00Theta720w,
                [IMAGE_BLURRED]: au00ThetaBlur720w,
            },
        },
        alpha: {
            desktop: {
                [IMAGE_NORMAL]: au01Alpha1920w,
                [IMAGE_BLURRED]: au01AlphaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: au01Alpha1280w,
                [IMAGE_BLURRED]: au01AlphaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: au01Alpha720w,
                [IMAGE_BLURRED]: au01AlphaBlur720w,
            },
        },
        beta: {
            desktop: {
                [IMAGE_NORMAL]: au02Beta1920w,
                [IMAGE_BLURRED]: au02BetaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: au02Beta1280w,
                [IMAGE_BLURRED]: au02BetaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: au02Beta720w,
                [IMAGE_BLURRED]: au02BetaBlur720w,
            },
        },
        gamma: {
            desktop: {
                [IMAGE_NORMAL]: au03Gamma1920w,
                [IMAGE_BLURRED]: au03GammaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: au03Gamma1280w,
                [IMAGE_BLURRED]: au03GammaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: au03Gamma720w,
                [IMAGE_BLURRED]: au03GammaBlur720w,
            },
        },
        delta: {
            desktop: {
                [IMAGE_NORMAL]: au04Delta1920w,
                [IMAGE_BLURRED]: au04DeltaBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: au04Delta1280w,
                [IMAGE_BLURRED]: au04DeltaBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: au04Delta720w,
                [IMAGE_BLURRED]: au04DeltaBlur720w,
            },
        },
        epsilon: {
            desktop: {
                [IMAGE_NORMAL]: au05Epsilon1920w,
                [IMAGE_BLURRED]: au05EpsilonBlur1920w,
            },
            tablet: {
                [IMAGE_NORMAL]: au05Epsilon1280w,
                [IMAGE_BLURRED]: au05EpsilonBlur1280w,
            },
            mobile: {
                [IMAGE_NORMAL]: au05Epsilon720w,
                [IMAGE_BLURRED]: au05EpsilonBlur720w,
            },
        },
    },
};
